import { Directive, HostListener, Input } from "@angular/core";
import { Store } from "@ngrx/store";

import { CoreState } from "../state";

import { CommandDispatcherAction } from "./command-dispatcher.action";
import { CommandType } from "./command-dispatcher.model";

@Directive({
	selector: "[obgCommandDispatcher]",
})
export class CommandDispatcherDirective {
	@Input("obgCommandDispatcher") commandName: CommandType | undefined;

	constructor(
		private store: Store<CoreState>,
		private action: CommandDispatcherAction
	) {}

	@HostListener("click", ["$event"])
	onClick(event: MouseEvent) {
		if (!this.commandName) {
			return;
		}

		this.store.dispatch(this.action.trigger(this.commandName));
		event.preventDefault();
	}
}
